<template>
  <section class="legal">
    <div class="legal__title">
      <h1 class="text-head-1 text-bold text-sora"  v-html="$t('legal.policy.page_title')"/>
      <h2 class="text-body-2 text-regular">
        {{
          $t("legal.policy.page_update_date", {
            date: new Intl.DateTimeFormat("en-US").format(new Date())
          })
        }}
      </h2>
    </div>
    <section class="legal__info">
      <legal-sidebar
        v-if="!$device.isMobile"
        ref="sideBarRef"
        :titles="headers"
        @click-title="handleClickTitle"
      />
      <base-separator
        v-if="!$device.isMobile"
        vertical
        :style="{ height: sideBarNode?.sideBarRef?.clientHeight + 'px' }"
      />
      <div class="text">
        <span id="0" class="text__paragraph">
          <h5 class="text-head-2 text-bold text-sora" v-html="$t('legal.policy.headers.0')"/>
          <p class="text-body-1"  v-html="$t('legal.policy.paragraphs.0.text')"/>
          <p class="text-body-1"  v-html="$t('legal.policy.paragraphs.1.text')"/>
          <p class="text-body-1"  v-html="$t('legal.policy.paragraphs.2.text')"/>
        </span>
        <span id="1" class="text__paragraph">
          <h5 class="text-head-2 text-bold text-sora" v-html="$t('legal.policy.headers.1')"/>
          <span>
            <p class="text-body-1"  v-html="$t('legal.policy.paragraphs.3.text')"/>
          <p class="text-body-1"  v-html="$t('legal.policy.paragraphs.4.text')"/>
            <ul class="ul-style ul-style--dots text-body-1" v-html="$t('legal.policy.ul.0')"/>
            <br >
            <p class="text-body-1"  v-html="$t('legal.policy.paragraphs.5.text')"/>
          </span>
        </span>
        <span id="2" class="text__paragraph">
          <h5 class="text-head-2 text-bold text-sora" v-html="$t('legal.policy.headers.2')"/>
          <span>
            <p class="text-body-1" v-html="$t('legal.policy.paragraphs.6.text')"/>
            <ul class="ul-style ul-style--dots text-body-1"  v-html="$t('legal.policy.ul.1')"/>
            <br >
            <p class="text-body-1"  v-html="$t('legal.policy.paragraphs.7.text')"/>
          </span>
        </span>
        <span id="3" class="text__paragraph">
          <h5 class="text-head-2 text-bold text-sora" v-html="$t('legal.policy.headers.3')"/>
          <span>
            <p class="text-body-1"  v-html="$t('legal.policy.paragraphs.8.text')"/>
            <br >
            <p class="text-body-1 text-violet-main" v-html="$t('legal.policy.sub_headers.0')"/>
            <p class="text-body-1"  v-html="$t('legal.policy.paragraphs.9.text')"/>
            <ul class="ul-style ul-style--dots text-body-1"  v-html="$t('legal.policy.ul.2')"/>
            <br >
            <br >
            <p class="text-body-1"  v-html="$t('legal.policy.paragraphs.10.text')"/>
            <ul class="ul-style ul-style--dots text-body-1"  v-html="$t('legal.policy.ul.3')"/>
            <br >
            <br >
            <p class="text-body-1 text-violet-main" v-html="$t('legal.policy.sub_headers.1')"/>
            <p class="text-body-1"  v-html="$t('legal.policy.paragraphs.11.text')"/>
            <ul class="ul-style ul-style--dots text-body-1"  v-html="$t('legal.policy.ul.4')"/>
            <br >
            <br >
            <p class="text-body-1 text-violet-main" v-html="$t('legal.policy.sub_headers.2')"/>
            <p class="text-body-1"  v-html="$t('legal.policy.paragraphs.12.text')"/>
            <ul class="ul-style ul-style--dots text-body-1"  v-html="$t('legal.policy.ul.5')"/>
          </span>
        </span>
        <span id="4" class="text__paragraph">
          <h5 class="text-head-2 text-bold text-sora" v-html="$t('legal.policy.headers.4')"/>
          <span>
            <p class="text-body-1"  v-html="$t('legal.policy.paragraphs.13.text')"/>
            <ul class="ul-style ul-style--dots text-body-1"  v-html="$t('legal.policy.ul.6')"/>
            <br >
            <br >
            <p class="text-body-1"  v-html="$t('legal.policy.paragraphs.14.text')"/>
          </span>
        </span>
        <span id="5" class="text__paragraph">
          <h5 class="text-head-2 text-bold text-sora" v-html="$t('legal.policy.headers.5')"/>
          <span>
            <p class="text-body-1"  v-html="$t('legal.policy.paragraphs.15.text')"/>
            <ul class="ul-style ul-style--dots text-body-1"  v-html="$t('legal.policy.ul.7')"/>
            <br >
            <br >
            <p class="text-body-1"  v-html="$t('legal.policy.paragraphs.16.text')"/>
          </span>
        </span>
        <span id="6" class="text__paragraph">
          <h5 class="text-head-2 text-bold text-sora" v-html="$t('legal.policy.headers.6')"/>
          <span>
            <p class="text-body-1"  v-html="$t('legal.policy.paragraphs.17.text')"/>
            <ul class="ul-style ul-style--dots text-body-1"  v-html="$t('legal.policy.ul.8')"/>
          </span>
        </span>
        <span id="7" class="text__paragraph">
          <h5 class="text-head-2 text-bold text-sora" v-html="$t('legal.policy.headers.7')"/>
          <p class="text-body-1"  v-html="$t('legal.policy.paragraphs.18.text')"/>
        </span>
        <span id="8" class="text__paragraph">
          <h5 class="text-head-2 text-bold text-sora" v-html="$t('legal.policy.headers.8')"/>
          <p class="text-body-1"  v-html="$t('legal.policy.paragraphs.19.text')"/>
        </span>
        <span id="9" class="text__paragraph">
          <h5 class="text-head-2 text-bold text-sora" v-html="$t('legal.policy.headers.9')"/>
          <p class="text-body-1"  v-html="$t('legal.policy.paragraphs.20.text')"/>
        </span>
        <span id="10" class="text__paragraph">
          <h5 class="text-head-2 text-bold text-sora" v-html="$t('legal.policy.headers.10')"/>
          <p class="text-body-1"  v-html="$t('legal.policy.paragraphs.21.text')"/>
        </span>
        <span id="11" class="text__paragraph">
          <h5 class="text-head-2 text-bold text-sora" v-html="$t('legal.policy.headers.11')"/>
          <p class="text-body-1"  v-html="$t('legal.policy.paragraphs.22.text')"/>
          <p class="text-body-1"  v-html="$t('legal.policy.paragraphs.23.text')"/>
        </span>

        <span id="12" class="text__paragraph">
          <h5 class="text-head-2 text-bold text-sora" v-html="$t('legal.policy.headers.12')"/>
          <p class="text-body-1"  v-html="$t('legal.policy.paragraphs.24.text', {email:'hi@rwa-estate.com '})"/>
        </span>
      </div>
    </section>
  </section>
</template>

<script setup lang="ts">
const { tm } = useI18n()

const sideBarNode = useTemplateRef("sideBarRef")

const handleClickTitle = (val: string) => {
  if (val) {
    const element = document.getElementById(val)
    if (element) {
      element.scrollIntoView({ behavior: "smooth" })
    }
  }
}

const headers = computed(() => {
  const headersList = tm("legal.policy.nav") as unknown as {
    title: string
  }[]
  return headersList ?? []
})
</script>

<style scoped lang="scss">
h1 {
  word-break: break-word;
  overflow-wrap: break-word;
}
</style>
